import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-109a2818"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("发放行批量操作")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("解锁/锁定")
const _hoisted_4 = { class: "ml-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 生成支付单据")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("批量作废")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("更新")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("更新银行卡")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("重新生成清单")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("重新生成")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("更新")

import { ref, reactive, onActivated, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import type { TableColumnCtx } from 'element-plus'
// import ConnectFlows from './ConnectFlows'
import tbMix, {orgCfig, cpyCfig} from '@/global_mixin/tableMixin'
import { formatNumber, bankCardFormat, getNumber } from '@/utils/index'
import { useRoute } from 'vue-router'
import PaymentModuleUtils  from "@/views/typeMapping/PaymentModuleUtils"
import Api from '@/http/modules/index'
interface SummaryMethodProps<T = any> {
  columns: TableColumnCtx<T>[]
  data: T[]
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/payroll/detail/query': fetchList,
  // 获取发放行列表
  'GET/payroll/detail/bank_drop_list': bank_drop_listApi,
  // 工资发放清单_批量修改发放行
  'PUT/payroll/detail/update_pay_bank': update_pay_bankApi,
  // 工资发放清单_批量_锁定或解锁
  'PUT/payroll/detail/batch_locked': batch_lockedApi,
  // 工资发放清单_统计
  'POST/payroll/detail/query_summary': querySummaryApi,
  // 工资发放清单导出
  'POST/payroll/detail/export': exportApi,
  // 工资发放清单_批量删除
  'DELETE/payroll/detail': datailDeleteApi,
  // 工资发放清单_生成支付单据
  'POST/payroll/generate_pay_bill': generate_pay_bill,
  // 工资发放清单_重新生成支付单据
  'POST/payroll/repayments': repaymentsApi,
  // 工资发放清单_获取银行卡列表
  'GET/payroll/get_user_bank': get_user_bankApi,
  // 工资发放清单_更新工资发放清单
  'PATCH/payroll/renew': payrollRenewApi,
  // 工资发放清单_更新银行卡
  'PATCH/payroll/renew_bank_info': renew_bank_infoApi,
  // 检查离职材料
  'POST/user/material/check/resignation_file': resignation_fileApi,
} = Api
let { statusFilter } = PaymentModuleUtils
const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)
let selectRows: any = ref([])
const pageMainTable = ref()

const route = useRoute()
let corporateBanks = ref<any[]>([])
let isMounted = ref(false)
onMounted(() => {
  // 获取发放银行
  bank_drop_listApi().then((rep: any) => {
    corporateBanks.value = rep.bankNameList.map((e: string) => {
      return { label: e, id: e }
    }).concat([{label: '未选发放行', id: 'Invalid'}])
  })
  isMounted.value = true
})
let searchForm = ref()
let isShowBackBtn = ref(false)
onActivated(() => {
  if(Object.values(route.query).length > 0){
    searchForm.value.resetForm()
    Object.assign(searchForm.value.dataObj, route.query)
    searchHandle(route.query)
    // 返回按钮展示
    isShowBackBtn.value = true
  } else {
    isShowBackBtn.value = false
  }
})

const searchConfig = ref([
  {
    label: '姓名',
    value: '',
    upKey: 'userName',
  },
  {
    label: '持卡人',
    value: '',
    upKey: 'bankAccountName',
  },
  {
    type: 'SELECT',
    label: '银行卡类型',
    value: '',
    upKey: 'bankCartPurpose',
    options: [
      { label: '工资卡', id: '工资卡' },
      { label: '报销卡', id: '报销卡' },
      { label: '奖金卡', id: '奖金卡' },
      { label: '尽孝金卡', id: '尽孝金卡' },
    ],
    props: { clearable: true, placeholder: '请选择卡类型'},
    seleProps: {},
  },
  {
    type: 'SELECT',
    label: '生成支付单据',
    value: '',
    upKey: 'isGenerated',
    options: [
      { label: '可以', id: 0 },
      { label: '不可以', id: 1 },
    ],
    props: { clearable: true, placeholder: '请选择生成支付单据'},
    seleProps: {},
  },
  {
    type: 'SELECT',
    label: '锁定状态',
    value: '',
    upKey: 'locked',
    options: [
      { label: '未锁定', id: 0},
      { label: '已锁定', id: 1},
    ],
    props: { clearable: true, placeholder: '请选择锁定状态'},
    seleProps: {},
  },
  {
    type: "TIME",
    label: "日期",
    value: '',
    upKey: 'salaryDate',
    props: {
      'value-format': 'YYYY-MM-DD',
      clearable: true,
    }
  },
  {
    // type: 'NUMBER',
    label: '支付金额',
    value: '',
    upKey: 'payAmount',
    props: {
      type: 'number',
      clearable: true,
    }
  },
  {
    // type: 'NUMBER',
    label: '总金额',
    value: '',
    upKey: 'totalPayAmount',
    props: {
      type: 'number',
      clearable: true,
    }
  },
  {
    type: 'SELECT',
    label: '付款银行',
    value: '',
    upKey: 'payBank',
    options:corporateBanks,
    props: { clearable: true, placeholder: '请选择付款银行'},
    seleProps: {},
  },
  
  {
    label: '支付单据ID',
    value: '',
    upKey: 'billId',
  },
  {
    type: 'SELECT',
    label: '银行卡类型',
    value: '',
    upKey: 'bankCartPurpose',
    options: [
      { label: '工资卡', id: '工资卡' },
      { label: '报销卡', id: '报销卡' },
      { label: '奖金卡', id: '奖金卡' },
      { label: '尽孝金卡', id: '尽孝金卡' },
    ],
    props: { clearable: true, placeholder: '请选择卡类型'},
    seleProps: {},
  },
  {
    type: 'SELECT',
    label: '审批状态',
    value: '',
    upKey: 'approvedStatus',
    options: [
      { label: 'Hr审核', id: 'APPROVE_WAIT' },
      { label: '财务审核', id: 'APPROVE_SEC' },
      { label: '审核成功', id: 'APPROVE_SUCCESS' },
      { label: '已驳回', id: 'TRUN_DOWN' },
    ],
    props: { clearable: true, placeholder: '请选择审批状态'},
    seleProps: {},
  },
  {
    type: 'SELECT',
    label: '支付状态',
    value: '',
    upKey: 'detailPayStatus',
    options: [
      { label: '未支付', id: 'PAY_NO' },
      { label: '等待支付', id: 'PAY_WAIT' },
      { label: '支付成功', id: 'PAY_SUCCESS' },
      { label: '支付失败', id: 'PAY_FAILED' },
      { label: '已重新支付', id: 'PAYMENT_REISSUED' },
      { label: '部分支付成功', id: 'PAY_PART_SUCCESS' },
    ],
    props: { clearable: true, placeholder: '请选择支付状态'},
    seleProps: {},
  },
  {
    label: '批次id',
    value: '',
    upKey: 'distributeId',
  },
  cpyCfig({
    seleProps: { label: 'name', valueName: 'name'},
    upKey: 'companyName'
  }),
])

let summaryObj: any = reactive({})
const deleted = ref(false)
const searchHandle = (params: any) => {
  pageMainTable.value.clearSelection()
  params.deleted = deleted.value
  fetchData({query: params})
  querySummaryApi(params).then((sumObj: object) => {
    Object.assign(summaryObj, sumObj)
  })
}
// 批量操作发放行
const batchOperationFg = ref<boolean>(false)
const batchOperationConfig = ref([
  {
    type: 'SELECT',
    label: '发放行',
    value: '',
    upKey: 'payBank',
    options: corporateBanks,
    props: { clearable: true, placeholder: '请选择发放行'},
    seleProps: {},
  },
])
const batchOperation = () => {
  if(selectRows.value.length === 0){
    ElMessage.warning('请选择至少选择一条数据')
    return
  }
  MI_modifyForm({}, batchOperationConfig, batchOperationFg, async (params: any) => {
    await update_pay_bankApi({
      ids: selectRows.value.map((user: any) => user.id),
      ...params,

    })
    searchHandle(MI_params.query)
    batchOperationFg.value = false
    ElMessage.success('修改成功')
  })
}

// 锁定或者解锁
const toggleFg = ref<boolean>(false)
let toggleConfig = ref([
  {
    type: 'SELECT',
    label: '锁定状态',
    value: '',
    upKey: 'locked',
    options: [
      { label: '解锁', id: 0},
      { label: '锁定', id: 1},
    ],
    rule: [{ required: true, message: '请选择锁定状态', trigger: 'change' }],
    props: { clearable: false, placeholder: '请选择锁定状态'},
    seleProps: {},
  },
])
const toggleLock = () => {
  if(selectRows.value.length === 0){
    ElMessage.warning('请选择至少选择一条数据')
    return
  }
  
  MI_modifyForm({}, toggleConfig, toggleFg, (params: any) => {
    // 锁定前判断离职文件
    let promiselink = Promise.resolve()
    if(params.locked === 1){
      promiselink = resignation_fileApi({ids: selectRows.value.map((user: any) => user.id)}).then((rep: {errorData: string[]}) => {
        return ElMessageBox.confirm(rep.errorData.join(','), '以下离职员工附件未上传', {
          confirmButtonText: '依旧锁定',
          cancelButtonText: '暂不锁定',
          type: 'warning',
        })
      })

    }
    promiselink.then(() => {
      return batch_lockedApi({
        ids: selectRows.value.map((user: any) => user.id),
        ...params,
      })
    }).then(() => {
      searchHandle(MI_params.query)
      ElMessage.success('修改成功')
      toggleFg.value = false
    })
    
  })
}

// 从接口获取送机
const getApiSummary = (param: SummaryMethodProps) => {
  const { columns, data } = param
  const sums: string[] = ['合计']
  /* columns.forEach((column, index) => {
    if (index === 0) {
      sums[0] = '合计'
      return
    }
  }) */
  sums[12] = getNumber(summaryObj['filialSum'] + summaryObj['salarySum'])
  // sums[15] = getNumber(summaryObj['actualSalarySum'])

  return sums
}
// 生成支付单据
const generateBill = () => {
  MI_identify.value = true
  generate_pay_bill({
    ids: selectRows.value.map((user: any) => user.id),
    companyName: searchForm.value.dataObj.companyName,
    salaryDate: searchForm.value.dataObj.salaryDate,
    payBank: searchForm.value.dataObj.payBank,
  }).then(() => {
    ElMessage.success('成功')
    MI_identify.value = false
    searchHandle(MI_params.query)
  }).catch(() => {
    MI_identify.value = false
  })
}

// 删除
const batchDelHandle = () => {
  if(selectRows.value.length === 0){
    ElMessage.warning('请选择至少选择一条数据')
    return
  }
  ElMessageBox.confirm(
    '请确认是否作废?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    MI_identify.value = true
    return datailDeleteApi({ ids: selectRows.value.map((user: any) => user.id) })
  }).then(() => {
    ElMessage.success('删除成功')
    MI_identify.value = false
    searchHandle(MI_params.query)
  }).catch(() => {
    MI_identify.value = false
  })
}
// 根据id获取银行卡
let reGenerateTableDt: any = ref([])
const getUserCard = (obj: {id: string}) => {
  MI_identify.value = true
  return get_user_bankApi({id: obj.id}).then((rep) => {
    reGenerateTableDt.value = rep``
  }).finally(() => {
    MI_identify.value = false
  })
}
// 重新生成支付单据
let reGenerateBillRow = {id: ''}
const reGenerateFg = ref<boolean>(false)
const reGenerateBill = async (row: any) => {
  Object.assign(reGenerateBillRow, row)
  await getUserCard(row)
  reGenerateFg.value = true
}

const reGenerateBillSubmit = (row: any) => {
  MI_identify.value = true
  repaymentsApi({
    id: reGenerateBillRow.id,
    userBankId: row.id
  }, { contentType: 'formData' }).then(() => {
    MI_identify.value = false
    reGenerateFg.value = false
    searchHandle(MI_params.query)
  }).catch(() => {
    MI_identify.value = false
  })
}

// 更新

const reNewHandle = (row: {id: string}) => {
  ElMessageBox.confirm(
    '是否确认更新?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      MI_identify.value = true
      return payrollRenewApi({id: row.id}, { contentType: 'formData' })
    })
    .then(() => {
      MI_identify.value = false
      ElMessage.success('成功')
    })
    .catch(() => {
      MI_identify.value = false
    })
}
// 重新生成银行卡
const reNewCardFg = ref<boolean>(false)
let reNewCardRow = {id: ''}
const reNewCardHandke = async (row: any) => {
  Object.assign(reNewCardRow, row)
  await getUserCard(row)
  reNewCardFg.value = true
}

const reNewCardSubmit = (row: {id: string}) => {
  MI_identify.value = true
  renew_bank_infoApi({
    id: reNewCardRow.id,
    userBankId: row.id
  }, { contentType: 'formData' }).then(() => {
    MI_identify.value = false
    reNewCardFg.value = false
    searchHandle(MI_params.query)
  }).catch(() => {
    MI_identify.value = false
  })
}


// 关联交易流水
const isShowConnect = ref<boolean>(false)
const connectHandle = () => {
  for (let index = 0; index < selectRows.value.length; index++) {
    // 判断已生成支付单据
    if(selectRows.value[index].isGenerated !== 0){
      // 已生成
      ElMessage.warning('所选数据已生成支付单据！')
      return
    }
    // 判断支付状态
    if(selectRows.value[index].detailPayStatus !== 'PAY_NO'){
      // 已生成
      ElMessage.warning('所选数据已支付或已关联流水！')
      return
    }
    
  }
  isShowConnect.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "工资发放清单" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
              ref_key: "searchForm",
              ref: searchForm
            }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_unref(isShowBackBtn))
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "info",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "primary",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (batchOperation())),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleLock())),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Write']
    ]),
    _createVNode(_component_el_tooltip, {
      effect: "dark",
      content: "请先搜索后再导出",
      placement: "bottom-end"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          (_unref(isMounted))
            ? (_openBlock(), _createBlock(_component_eptBtn, {
                key: 0,
                exportFn: _unref(exportApi),
                exportText: "导出工资发放清单",
                exportParam: _unref(searchForm).dataObj
              }, null, 8, ["exportFn", "exportParam"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_tooltip, {
      effect: "dark",
      content: "请先搜索后再生成支付单据",
      placement: "top-end"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "ml-10",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (generateBill())),
            disabled: _unref(MI_identify)
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["disabled"])), [
            [_directive_permission, 'Write']
          ])
        ])
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      class: "ml-10",
      type: "danger",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (batchDelHandle())),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Delete']
    ]),
    _createVNode(_component_el_checkbox, {
      modelValue: deleted.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((deleted).value = $event)),
      label: "是否含作废",
      disabled: _unref(MI_identify),
      border: "",
      class: "ml-10",
      style: {"transform":"translateY(3px)"},
      onChange: _cache[6] || (_cache[6] = ($event: any) => (searchHandle(_unref(MI_params).query)))
    }, null, 8, ["modelValue", "disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref_key: "pageMainTable",
      ref: pageMainTable,
      border: "",
      data: _unref(MI_tableData),
      "row-key": "id",
      class: "mt-10",
      "show-summary": "",
      "summary-method": getApiSummary,
      onSelectionChange: _cache[7] || (_cache[7] = (rows) => { _isRef(selectRows) //@ts-ignore
 ? selectRows.value = rows : selectRows = rows }),
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55",
          fixed: "",
          "reserve-selection": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          width: "180",
          prop: "companyName",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "用户名",
          width: "115",
          prop: "username",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "锁定状态",
          width: "100",
          prop: "locked",
          "show-overflow-tooltip": "",
          formatter: (row) => row.locked === 0 ? '未锁定' : '已锁定'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "审核状态",
          width: "100",
          prop: "approvedStatus",
          "show-overflow-tooltip": "",
          formatter: (row) => _unref(statusFilter)(row.approvedStatus)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "支付状态",
          width: "100",
          prop: "detailPayStatus",
          "show-overflow-tooltip": "",
          formatter: (row) => _unref(statusFilter)(row.detailPayStatus)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "是否作废",
          width: "100",
          prop: "deleted",
          "show-overflow-tooltip": "",
          formatter: (row) => row.deleted === false ? '未作废' : '已作废'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "已生成支付单据",
          width: "130",
          prop: "isGenerated",
          "show-overflow-tooltip": "",
          formatter: (row) => row.isGenerated === 0 ? '未生成' : '已生成'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "支付ID",
          width: "80",
          prop: "billId",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "持卡人",
          prop: "bankAccountName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "证件号码",
          width: "100",
          prop: "cardId",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "卡类型",
          prop: "bankCartPurpose",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "金额",
          width: "110",
          align: "right",
          formatter: _unref(formatNumber),
          prop: "payAmount",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "开户行",
          prop: "bankName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "开户行信息",
          width: "100",
          prop: "bankLocation",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "卡号",
          width: "200",
          prop: "bankAccount",
          "show-overflow-tooltip": "",
          formatter: (row) => _unref(bankCardFormat)(row.bankAccount)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "比例",
          align: "right",
          width: "60",
          prop: "weight",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "原始金额",
          width: "115",
          align: "right",
          formatter: _unref(formatNumber),
          prop: "totalPayAmount",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "工资日期",
          width: "100",
          prop: "salaryDate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "实际发放行",
          width: "110",
          prop: "actualPaymentBank",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "230",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              onClick: ($event: any) => (reNewHandle(row)),
              type: "primary",
              class: "mr-10"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_link, {
              onClick: ($event: any) => (reNewCardHandke(row)),
              type: "primary",
              class: "mr-10"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_link, {
              onClick: ($event: any) => (reGenerateBill(row))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[9] || (_cache[9] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      disabled: _unref(MI_identify),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50, 100, 500, 1000, 1500],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "disabled", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "发放行批量操作",
      modelValue: batchOperationFg.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((batchOperationFg).value = $event))
    }, {
      default: _withCtx(() => [
        (batchOperationFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: batchOperationConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "锁定解锁",
      modelValue: toggleFg.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((toggleFg).value = $event))
    }, {
      default: _withCtx(() => [
        (toggleFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: _unref(toggleConfig),
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "重新生成支付单据",
      modelValue: reGenerateFg.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((reGenerateFg).value = $event))
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          "max-height": "400",
          data: _unref(reGenerateTableDt)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "持卡人",
              prop: "name",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "银行简称",
              prop: "bankAlias",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "开户行信息",
              width: "155",
              prop: "location",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              width: "200",
              label: "卡号",
              prop: "account",
              formatter: (row) => _unref(bankCardFormat)(row.account)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "卡类型",
              prop: "purpose",
              width: "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (reGenerateBillSubmit(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(MI_identify)]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "更新银行卡",
      modelValue: reNewCardFg.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((reNewCardFg).value = $event))
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          "max-height": "400",
          data: _unref(reGenerateTableDt)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "持卡人",
              prop: "name",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "银行简称",
              prop: "bankAlias",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "开户行信息",
              width: "155",
              prop: "location",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              width: "200",
              label: "卡号",
              prop: "account",
              formatter: (row) => _unref(bankCardFormat)(row.account)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "卡类型",
              prop: "purpose",
              width: "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (reNewCardSubmit(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(MI_identify)]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})